import { USER_LOGIN_DATA, WOH_AM_I_DATA } from "../api/url";

export const getWhoAmIToken = () => {
  const authStr = localStorage.getItem(WOH_AM_I_DATA);
  if (authStr) {
    const authJSON = JSON.parse(authStr);
    return authJSON?.data;
  }
  return null;
};

export const getUserAuthToken = () => {
  const authStr = localStorage.getItem(USER_LOGIN_DATA);
  if (authStr) {
    const authJSON = JSON.parse(authStr);
    return authJSON.data.Token;
  }
  return null;
};

export const setLocalStorageItem = (key: string, data: any) => {
  localStorage.setItem(key, JSON.stringify(data));
};

export const getLocalStorageItem = (key: string) => {
  const item = localStorage.getItem(key);
  if (item) {
    return JSON.parse(item);
  }
  return null;
};

export const deleteLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
};
